(ns app.front.view.payment.checkout
  (:require [core.front.event :refer [<sub]]
            [potpuri.core :as p]
            [re-frame.core-instrumented :as rf]))

(rf/reg-sub ::transaction-details :-> ::transaction-details)



(rf/reg-sub ::payment-return-route :-> ::payment-return-route)

;; Default return target set by flows (e.g. the application wizard payment step)
;; that want bill payments initiated from shared components to come back to them.
(rf/reg-event-db ::set-default-return-opts
  (fn [db [_ opts]]
    (assoc db ::default-return-opts opts)))

(rf/reg-event-db ::clear-default-return-opts
  (fn [db _]
    (dissoc db ::default-return-opts)))

(rf/reg-sub ::default-return-opts :-> ::default-return-opts)

(defn return-nav-fx
  "Resolves the post-payment navigation effect. Prefers the wizard-set
   return route, falls back to the provider's default."
  [db default-route default-params]
  (let [{:keys [route params]} (::payment-return-route db)]
    {:db            (dissoc db ::payment-return-route)
     :route/replace {:route  (or route default-route)
                     :params (or params default-params)}}))


(defmulti payment-form :provider)


(defmulti payment-service-effects :provider)


(defmethod payment-service-effects :default
  [_transaction-details]
  [])


(defn view [match]
  (let [transaction-details (<sub [::transaction-details])
        workspace-id        (-> match :parameters :path :workspace-id)
        escrow-account      (-> match :parameters :path :account-id)]
    (when transaction-details
      [payment-form (-> transaction-details
                        (p/assoc-if :workspace-id workspace-id
                                    :escrow-account escrow-account))])))

(def checkout-route
  {:view          view
   :own-layout?   true
   :plain-header? true
   :hide-footer?  true})

(def route
  (merge checkout-route
         {:name :view/payment-checkout}))

(def route-escrow
  (merge checkout-route
         {:name :view/payment-checkout-escrow}))
